export default "__VITE_ASSET__m6V2gkwP__"